import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Bill from './seat/Bill';
import HowPayDialog from './seat/HowPayDialog';
import { fetchDefault, getNowTimeStamp } from './Utils.js';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import AccessTimeIcon from '@material-ui/icons/AccessTime';
import InputAdornment from '@material-ui/core/InputAdornment';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';

const monthList = [
    {
        value: 1,
        label: '4주(28일)',
    },
    {
        value: 2,
        label: '8주(56일) 3% 추가할인',
    },
    {
        value: 3,
        label: '12주(84일) 6% 추가할인',
    },
    {
        value: 4,
        label: '16주(112일) 9% 추가할인',
    },
    {
        value: 5,
        label: '20주(140일) 12% 추가할인',
    },
    {
        value: 6,
        label: '24주(168일) 15% 추가할인',
    },
    {
        value: 7,
        label: '28주(196일) 18% 추가할인',
    },
    {
        value: 8,
        label: '32주(224일) 21% 추가할인',
    },
    {
        value: 9,
        label: '36주(252일) 24% 추가할인',
    },
    {
        value: 10,
        label: '40주(280일) 27% 추가할인',
    },
    {
        value: 11,
        label: '44주(308일) 30% 추가할인',
    },
    {
        value: 12,
        label: '48주(336일) 33% 추가할인',
    },
    {
        value: 13,
        label: '52주(364일) 36% 추가할인',
    }
];

const useStyles = makeStyles(theme => ({
    paper: {
        width: '100%',
        marginTop: 1,
        overflowX: 'auto',
    },
    textField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
    DateTextField: {
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
    CurrentDateTextField: {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(1),
        width: 280,
    },
    menu: {
        width: 180,
    },
}));

export default function Monthly() {
    const classes = useStyles();

    const [month, setMonth] = React.useState();
    const [startDateTime, setStartDateTime] = React.useState('');
    
    const [originalPrice, setOriginalPricet] = React.useState();
    const [memberDiscount, setMemberDiscount] = React.useState();
    const [doubleDiscount, setDoubleDiscount] = React.useState();
    const [usePoint, setUsePoint] = React.useState();
    const [myPoint, setMyPoint] = React.useState();
    const [totalPrice, setTotalPrice] = React.useState();

    const [currentMonthly, setCurrentMonthly] = React.useState();

    const [monthlyList, setMonthlyList] = React.useState();


    const [isSelected, setIsSelected] = React.useState(false);
    const onMonthChange = event => {
        if (!isSelected) {
            setMonth(event.target.value);
            setBill(event.target.value);

            setTimeout(function () { setIsSelected(false); }, 1000);
        }
        setIsSelected(true);
    };


    useEffect(() => {

        fetchDefault('/Payment/GetCurrentMonthly',
            (data) => {
                if (data.endDateTime) {
                    const date = data.endDateTime.substring(0, 16);
                    setStartDateTime(date);
                    setCurrentMonthly(date);
                } else {
                    setStartDateTime(getNowTimeStamp());
                }
            }
        );

        fetchDefault('/Payment/GetMonthlyList',
            (data) => {
                setMonthlyList(data);
            }
        );

        //계산
        //setBill(month);
        //판매중지 확인용
        fetchDefault('/Payment/GetMonthBill?month=1',(data) => {});

        return () => {
        }
    }, []);

    const setBill = (month) => {
        fetchDefault('/Payment/GetMonthBill?month=' + month + '&startDateTime=' + startDateTime,
            (data) => {
                setOriginalPricet(data.originalPrice);
                setMemberDiscount(data.memberDiscount);
                setDoubleDiscount(data.doubleDiscount);
                setUsePoint(data.usePoint);
                setTotalPrice(data.totalPrice);
                setMyPoint(data.myPoint);
            }
        );

    }

    return (
        <div className={classes.root}>
            <Grid container spacing={1}>
                <Grid item xs={12}>
                    <h2>월정액</h2>
                </Grid>
                <Grid item xs={12}>
                    <Card>
                        <CardContent>
                            <Typography variant="body1">
                                월정액 구입 후 개인석 이용시 사용시간 상관없이 요금이 0원으로 계산됩니다. (책상에 짐 보관불가 / 실제 사용 시간만 예약 가능)
                            </Typography>
                            {currentMonthly ? (
                                    <TextField
                                        id="currentMonthly"
                                        label="현재 월정액 종료날짜"
                                        readOnly
                                        className={classes.CurrentDateTextField}
                                        type="datetime-local"
                                        value={currentMonthly}
                                    />
                            ) : (<div></div>)}
                        </CardContent>
                    </Card>
                </Grid>
                {monthlyList ? (
                    <Grid item xs={12}>
                        {monthlyList.map(monthly => (
                            <Card style={{ marginBottom: 5 }}>
                                <CardContent>
                                    <Typography variant="body1">
                                        월정액 시작 : {monthly.startDateTime}
                                    </Typography>
                                    <Typography variant="body1">
                                        월정액 종료 : {monthly.endDateTime}
                                    </Typography>
                                </CardContent>
                            </Card>
                        ))}
                    </Grid>
                ) : (<Grid></Grid>)}
                <Grid item xs={12}>
                    <Typography variant="h6">
                        1. 기간을 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="outlined-select-currency"
                        select
                        label="기간"
                        className={classes.textField}
                        value={month}
                        onChange={onMonthChange}
                        SelectProps={{
                            MenuProps: {
                                className: classes.menu,
                            },
                        }}
                        margin="normal"
                        variant="outlined"
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <AccessTimeIcon />
                                </InputAdornment>
                            ),
                        }}
                    >
                        {monthList.map(option => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        2. 시작날짜를 선택해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        id="datetime-local"
                        label="시작날짜"
                        className={classes.DateTextField}
                        type="datetime-local"
                        value={startDateTime}
                        onChange={e => setStartDateTime(e.target.value)}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        3. 결제를 진행해주세요.
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Bill originalPrice={originalPrice} memberDiscount={memberDiscount} doubleDiscount={doubleDiscount} usePoint={usePoint} myPoint={myPoint} totalPrice={totalPrice} />
                </Grid>
                <Grid item xs={12}>
                    <HowPayDialog usePoint={usePoint} totalPrice={totalPrice} controllerUrl={'/Payment/PayMontly?startDateTIme=' + startDateTime + '&month=' + month}/>
                </Grid>
            </Grid>
        </div>
    );

}



// WEBPACK FOOTER //
// ./src/components/Monthly.js